import { environment } from "src/environments/environment";

export class Constants {
    public static baseURL = environment.baseURL;
    public static signalR_URL = environment.signalR_URL;
}
